import { Text } from '@adc/parallax-component-library';
import { ThemedImage } from 'Components/utility';
import i18n from 'Utilities/i18n';

const ResetFailure = () => {
  return (
    <>
      <ThemedImage
        resourceKey="ResetPasswordFailure.content.resetPasswordFailureContent.media.pwResetLockLight"
        alt="password reset failure illustration"
        id="ResetPasswordFailure.content.resetPasswordFailureContent.media.pwResetLock"
        style={{
          marginTop: '40px',
          height: '105px',
          objectFit: 'contain',
        }}
      />

      <Text
        nativeID="ResetPasswordFailure.content.resetPasswordFailureContent.primaryText"
        fontWeight="$h2.medium"
        fontSize="$h2.medium"
        color="$text.100"
        display="flex"
        flexDirection="column"
        textAlign="center"
      >
        {i18n.t('ResetPasswordFailure.content.resetPasswordFailureContent.primaryText')}
      </Text>

      <Text
        nativeID="ResetPasswordFailure.content.resetPasswordFailureContent.secondaryText"
        color="$text.80"
        textAlign="center"
      >
        {i18n.t('ResetPasswordFailure.content.resetPasswordFailureContent.secondaryText')}
      </Text>
    </>
  );
};

export { ResetFailure };
